(function(){
  function init(root){
    if(root.dataset.ready) return; root.dataset.ready='1';
    var track=root.querySelector('[data-pl2-track]');
    var slides=[].slice.call(track.children);
    var gos=[].slice.call(root.querySelectorAll('[data-pl2-go]'));
    var status=root.querySelector('[data-pl2-status]');
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur=-1, n=slides.length;
    if(!n) return;
    function center(i){var s=slides[i]; return s.offsetLeft-(track.clientWidth-s.offsetWidth)/2;}
    function nearest(){
      var c=track.scrollLeft+track.clientWidth/2, best=0, bd=Infinity;
      slides.forEach(function(s,i){var m=s.offsetLeft+s.offsetWidth/2, d=Math.abs(m-c); if(d<bd){bd=d;best=i;}});
      return best;
    }
    function go(i){
      i=(i+n)%n;
      track.scrollTo({left:center(i),behavior:reduce?'auto':'smooth'});
      set(i);
    }
    function set(i,force){
      if(i===cur&&!force) return; cur=i;
      slides.forEach(function(s,j){
        var on=j===i; s.classList.toggle('on',on); s.setAttribute('aria-hidden',on?'false':'true');
        s.querySelectorAll('.pl2-info a').forEach(function(a){a.tabIndex=on?0:-1;});
      });
      gos.forEach(function(g){
        var on=+g.getAttribute('data-pl2-go')===i;
        if(g.classList.contains('pl2-dot')) g.setAttribute('aria-current',on?'true':'false'); else g.setAttribute('aria-pressed',on?'true':'false');
      });
      if(status&&root.offsetParent!==null) status.textContent='Showing '+slides[i].getAttribute('data-name')+', '+(i+1)+' of '+n;
    }
    function refresh(i){ i=i||0; track.scrollLeft=center(i); set(i,true); }
    var t; track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){if(root.offsetParent!==null) set(nearest());},80);},{passive:true});
    root.querySelectorAll('[data-pl2-prev]').forEach(function(b){b.addEventListener('click',function(){go(cur-1);});});
    root.querySelectorAll('[data-pl2-next]').forEach(function(b){b.addEventListener('click',function(){go(cur+1);});});
    gos.forEach(function(g){g.addEventListener('click',function(){go(+g.getAttribute('data-pl2-go'));});});
    slides.forEach(function(s,i){s.addEventListener('click',function(e){if(i!==cur){e.preventDefault();go(i);}},true);});
    root.addEventListener('keydown',function(e){
      if(e.target.closest('.pl2-chips')) return;
      var k=e.key;
      if(k==='ArrowRight'){e.preventDefault();go(cur+1);}
      else if(k==='ArrowLeft'){e.preventDefault();go(cur-1);}
      else if(k==='Home'){e.preventDefault();go(0);}
      else if(k==='End'){e.preventDefault();go(n-1);}
    });
    window.addEventListener('resize',function(){ if(root.offsetParent!==null){ track.scrollLeft=center(cur); } });
    root._pl2={refresh:refresh};
    refresh(0);
  }
  function initTabs(sec){
    if(sec.dataset.tabs) return; sec.dataset.tabs='1';
    var tabs=[].slice.call(sec.querySelectorAll('[data-pl2-tab]'));
    var sel=sec.querySelector('[data-pl2-select]');
    var panels=[].slice.call(sec.querySelectorAll('[data-pl2-panel]'));
    if(panels.length<2) return;
    function show(k,focusTab){
      panels.forEach(function(p,j){ p.hidden=j!==k; });
      tabs.forEach(function(b,j){ var on=j===k; b.setAttribute('aria-selected',on?'true':'false'); b.tabIndex=on?0:-1; if(on&&focusTab) b.focus(); });
      if(sel) sel.value=String(k);
      var car=panels[k].querySelector('[data-pl2]');
      if(car){ init(car); if(car._pl2) car._pl2.refresh(0); }
    }
    tabs.forEach(function(b,j){
      b.addEventListener('click',function(){show(j);});
      b.addEventListener('keydown',function(e){
        var m=tabs.length, k=null;
        if(e.key==='ArrowRight') k=(j+1)%m; else if(e.key==='ArrowLeft') k=(j-1+m)%m; else if(e.key==='Home') k=0; else if(e.key==='End') k=m-1;
        if(k!==null){ e.preventDefault(); show(k,true); }
      });
    });
    if(sel) sel.addEventListener('change',function(){ show(+sel.value); });
  }
  function all(){
    document.querySelectorAll('[data-pl2]').forEach(init);
    document.querySelectorAll('[data-pl2-root]').forEach(initTabs);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',function(e){
    e.target.querySelectorAll('[data-pl2]').forEach(init);
    e.target.querySelectorAll('[data-pl2-root]').forEach(initTabs);
  });
})();
